import * as accountListActions from '../actions/accountListActions';
const initialState = {};
export default (state = initialState, action) => {
  //NOSONAR
  if (action.type === accountListActions.ACCOUNT_LIST_RESPONSE) {
    return {
      ...state,
      responseData: {
        ...action.data.data,
      },
    };
  }
  return state;
};
